const COBBLESTONE_SOUNDS = ["cobblestone1", "cobblestone2", "cobblestone3"];

export function playCobblestoneSound(k) {
    const random = COBBLESTONE_SOUNDS[Math.floor(Math.random() * COBBLESTONE_SOUNDS.length)];
    k.play(random, {
        volume: 0.4 + Math.random() * 0.2,   // entre 0.4 et 0.6
        speed: 0.9 + Math.random() * 0.2,    // entre 0.9 et 1.1
    });
}